import { render, staticRenderFns } from "./ContactRecordMessage.vue?vue&type=template&id=20c558e5&"
import script from "./ContactRecordMessage.vue?vue&type=script&lang=js&"
export * from "./ContactRecordMessage.vue?vue&type=script&lang=js&"
import style0 from "./ContactRecordMessage.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports